import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function BillingSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [me, setMe] = useState(null);

    useEffect(() => {
        // Give the webhook a couple of seconds to fire, then refresh /auth/me.
        const t = setTimeout(() => {
            api.get("/auth/me").then(({ data }) => setMe(data)).catch(() => setMe(false));
        }, 1500);
        return () => clearTimeout(t);
    }, [sessionId]);

    return (
        <div className="bg-background min-h-[70vh] flex items-center" data-testid="billing-success-page">
            <div className="mx-auto max-w-xl px-6 text-center">
                <div className="mx-auto w-14 h-14 rounded-full bg-emerald-500/10 border border-emerald-500/40 flex items-center justify-center">
                    <CheckCircle2 size={28} className="text-emerald-500" />
                </div>
                <h1 className="mt-4 font-heading font-medium text-3xl sm:text-4xl tracking-tight text-foreground">
                    You&apos;re all set.
                </h1>
                <p className="mt-3 text-sm text-muted-foreground">
                    Payment received. It can take a few seconds for your subscription to activate — we&apos;ll refresh your account automatically.
                </p>
                <div className="mt-6">
                    {me === null ? (
                        <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
                            <Loader2 size={13} className="animate-spin" /> Refreshing your account…
                        </div>
                    ) : (
                        <div className="flex flex-col sm:flex-row items-stretch gap-2 justify-center">
                            <Link to="/dashboard" className="btn-green text-sm inline-flex items-center justify-center gap-1" data-testid="billing-success-continue">
                                Continue to dashboard <ArrowRight size={13} />
                            </Link>
                            <Link to="/pricing" className="btn-outline text-sm inline-flex items-center justify-center gap-1">
                                Back to pricing
                            </Link>
                        </div>
                    )}
                </div>
                <p className="mt-8 text-[11px] text-muted-foreground">
                    Session ref: <span className="mono-score">{sessionId?.slice(0, 20) || "—"}…</span>
                </p>
            </div>
        </div>
    );
}
